module.exports = __webpack_public_path__ + "media/music2.fdd76c3d.mp3";